import React, { useState } from "react";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";

const ScvCircleInnerReportedVehicleRCV = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();

  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Circle",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Ward",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["wardName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Type",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["vehicleTypeName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Owner Type",
      selector: (row) => (
        <span
        >
          {row["ownerTypeName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Capacity",
      selector: (row) => (
        <span
        >
          {row["vehicleCapacityName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Uid",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        >{row["vehicleUuid"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Number",
      selector: (row) => (
        <span > {row["vehicleNumber"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Chassis Number",
      selector: (row) => (
        <span > {row["chassisNumber"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Code",
      selector: (row) => (
        <span > {row["vehicleCode"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Status",
      selector: (row) => (
        <span > {row["vehicleStatusName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Contractor Name",
      selector: (row) => (
        <span > {row["contractorName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Brand",
      selector: (row) => (
        <span > {row["vehicleBrandName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Driver",
      selector: (row) => (
        <span > {row["driverName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Driver Number",
      selector: (row) => (
        <span > {row["driverNumber"] || "N/A"}</span>
      ),
      sortable: true,
    },

    // {
    //   name: <>Primary<br/>Deployment Incharge</>,
    //   selector: (row) => (
    //     <span > {row["primaryDeploymentInchargeName"]}</span>
    //   ),
    //   sortable: true,
    // },
    {
      name: <>Secondary<br/>Deployment Incharge</>,
      selector: (row) => (
        <span > {row["secondaryDeploymentInchargeName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Transfer Station",
      selector: (row) => (
        <span > {row["transferStationName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Remark",
      selector: (row) => (
        <span > {row["remark"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "RC Image",
      cell: (row) => {
        if (row["rcimageUrl"]) {
          return (
            <img
              src={row["rcimageUrl"]}
              alt="Vehicle"
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
          );
        } else {
          return <span >No image</span>;
        }
      },
      sortable: true,
    },
    // {
    //   name: "RC Image",
    //   cell: (row) => {
    //     if (row["rcimageUrl"]) {
    //       return (
    //         <img
    //           src={row["rcimageUrl"]}
    //           alt="Vehicle"
    //           style={{ maxWidth: "100px", maxHeight: "100px" }}
    //         />
    //       );
    //     } else {
    //       return <span >No image</span>;
    //     }
    //   },
    //   sortable: true,
    // },
    {
      name: "PC Image",
      cell: (row) => {
        if (row["pcimageUrl"]) {
          return (
            <img
              src={row["pcimageUrl"]}
              alt="Vehicle"
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
          );
        } else {
          return <span >No image</span>;
        }
      },
      sortable: true,
    },
    {
      name: "Vehicle Image",
      cell: (row) => {
        if (row["vehicleImageUrl"]) {
          return (
            <img
              src={row["vehicleImageUrl"]}
              alt="Vehicle"
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
          );
        } else {
          return <span >No image</span>;
        }
      },
      sortable: true,
    },
  ];

  const downloadAsExcel = () => {
    if (!data) return; // Check if data is initialized
    // Add serial number to each item in the collection details
    const dataWithSerialNumber = data.map((item, index) => ({
      ...item,
      's.no': index + 1,
    }));
  
    // Filter out only the data corresponding to the headers displayed in the table component
    const filteredData = dataWithSerialNumber.map(item => ({
      's.no': item['s.no'],
      zone: item.zoneName?? "N/A",
      circle: item.circleName?? "N/A",
      ward: item.wardName?? "N/A",
      VehicleTypeName:item.vehicleTypeName?? "N/A",
      OwnerTypeName:item.ownerTypeName?? "N/A",
      VehicleCapacityName:item.vehicleCapacityName?? "N/A",
      VehicleUid:item.vehicleUuid?? "N/A",
      chassisNumber:item.chassisNumber?? "N/A",
      VehicleCode:item.vehicleCode?? "N/A",
      VehicleStatusName:item.vehicleStatusName?? "N/A",
      ContractorName:item.contractorName?? "N/A",
      VehicleBrandName:item.vehicleBrandName?? "N/A",
      DriverName:item.driverName?? "N/A",
      SecondaryDeploymentInchargeName:item.secondaryDeploymentInchargeName?? "N/A",
      TransferStationName:item.transferStationName?? "N/A",
      Remark:item.remark?? "N/A"
    }));
  
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SCVsInnerClearnceReport");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(excelBlob);
    downloadLink.download = "SCVsInnerClearnceReport.xlsx";
    downloadLink.click();
  };


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
            <div className="card">
              <div className="card-body">
            <div className="d-flex justify-content-end mt-3 mb-3">
              <button className="btn btn-secondary me-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                className="btn btn-excel"
                onClick={downloadAsExcel}
              >
             <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
              </button>
            </div>
            
                <div className="top-header">
                  <span>
                    {" "}
                    SCVs Repoted at Circle
                  </span>
                </div>

                <CustomDataTable data={data} columns={scvReportColumns} />
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};


export default ScvCircleInnerReportedVehicleRCV;
